import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import _ from "lodash";
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal } from "../../component/common"
import { PickupAndDropLocationModal} from "../../component/master"
import SimpleReactValidator from 'simple-react-validator';
import { getPickupDropListDetails, deletePickupDrop } from "../../redux/actions/master"

import { LoaderWrapper } from "../../HOC"
import { fromJS } from 'immutable';


class PickupAndDropLocationClass extends Component {
	state = {
		headerDetails: [
			{
				label: 'S.No',
			},
			{
				label: 'Name Pickup or Drop Location',
			},
			{
				label: 'Status',
			}
		],
		filter: [

			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 0
			}

		],
		pickupDropLocationLists: {

		},
		selectedFilter: 'Active',
		pickupDropDetails: {
			title: '',

		},
		isError: false,
		isOpen: false,
		isEdit: false,
		ConfirmModalOpenStatus: false,
		id: ''
	}


	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentDidMount() {
		this.setState({
			pickupDropLocationLists: this.props.pickupDropLocationLists
		})

	}


	requestStatus = (status) => {

		if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		} else if (status === 2) {
			return <Badge
				type={2}
				label={"Deactive"}
			/>
		}

	}
	handleAdd = () => {

		let temp = {
			name: ''
		}
		this.setState({
			isOpen: true,
			pickupDropDetails: temp
		})
	}

	handleEdit = (index) => {

		let {pickupDropLocationLists} = this.props;
		let pickupDropDetails = pickupDropLocationLists[index]

		this.setState({
			isEdit: true,
			pickupDropDetails,
			currentIndex: index

		})

		this.toggle("isOpen")

	}

	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}

	handleModal = () => {

		let temp = {
			name: '',
		}

		this.setState({
			isError: false,
			isOpen: false,
			isEdit: false,
			pickupDropDetails: temp

		})
	}

	handleDeleteToggle = (id) => {

		this.setState({
			id
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {
		let { id } = this.state

		this.props.deletePickupDrop(id).then(() => {

			this.props.getPickupDropListDetails()

			this.toggleDelete("ConfirmModalOpenStatus")

		})

	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}



	render() {

		let { headerDetails, filter, selectedFilter, pickupDropDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus } = this.state
		let { pickupDropLocationLists } = [];
		pickupDropLocationLists= _.filter(this.props.pickupDropLocationLists,(pickupDropLocation)=>{
			return pickupDropLocation.status===1;
		})
		let IsEmpty = pickupDropLocationLists.length > 0

		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>Pickup and Drop Location
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleAdd()}
						>Add Pickup Drop Location</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center">Pickup and Drop Location List</h5>
								<div className="ml-auto d-flex align-items-center">
								

									<div className="search-box position-relative  ml-3">

										
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									>
									{pickupDropLocationLists.map((item, index) => {
										let { id, title, status } = item

										return (
											<tr
												key={index}  >
												<td>{index+1}</td>
												<td>{title}</td>
												<td>{this.requestStatus(status)}</td>
												<td>
													
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>



				<SliderOverlay isOpen={isOpen} toggle={this.handleModal} size='30%'>
					<div className="side-slider h-100 position-relative">
						<div className="h-100 flex-with-center">
							<PickupAndDropLocationModal
								isError={isError}
								toggle={this.handleModal}
								isEdit={isEdit}
								modalDetails={pickupDropDetails}
							/>
						</div>

					</div>
				</SliderOverlay>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete Category?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		pickupDropLocationLists: state.master.pickupDropLocationLists
	}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getPickupDropListDetails,
		deletePickupDrop
	}, dispatch)
};

let actions = ['getPickupDropListDetails']

let component = LoaderWrapper(PickupAndDropLocationClass)({ actions })


export const PickupAndDropLocation = connect(mapStateToProps, mapDispatchToProps)(component)